import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AuthLayout from '../../components/shared/AuthLayout/AuthLayout';
import { unsubscribeReferralRoundup } from '../../redux/actions/unsubscribeActions';

import styles from './Unsubscribe.module.scss';

const Unsubscribe = () => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isLoading, isUnsubscribed, error } = useSelector((state) => state.unsubscribeReducer);

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      dispatch(unsubscribeReferralRoundup(token));
    } else {
      // Redirect to home page if no token is provided
      navigate('/');
    }
  }, [dispatch, searchParams, navigate]);

  const renderContent = () => {
    if (isLoading) {
      return <div className={styles.spinner}>{t('loading')}</div>;
    }

    const contentWrapper = (
      <div className={styles.contentWrapper}>
        <div className={styles.textContainer}>
          {error ? (
            <>
              <h2 className={styles.titleError}>{t('unsubscribe.failed')}</h2>
              <p className={styles.description}>{t('unsubscribe.errorMessage')}</p>
            </>
          ) : (
            <>
              <h2 className={styles.title}>{t('unsubscribe.success')}</h2>
              <p className={styles.description}>{t('unsubscribe.successMessage')}</p>
            </>
          )}
        </div>
      </div>
    );

    if (error || isUnsubscribed) {
      return contentWrapper;
    }

    return null;
  };

  return (
    <AuthLayout>
      <div className={styles.container}>{renderContent()}</div>
    </AuthLayout>
  );
};

export default Unsubscribe;
